import LoadingAlert from 'components/base/empty-states/LoadingAlert';
import AvgVelocityInfo from './AvgVelocityInfo';
import GranularityToggler from './GranularityToggler';
import { StyledHeader } from './Header.style';
import useLoadingTimerAlert from './useLoadingTimerAlert';

const Header = ({
  granularity,
  setGranularity,
  type,
  avgVelocity,
  isLoading
}) => {
  const loadingTimerAlert = useLoadingTimerAlert(isLoading);

  return (
    <StyledHeader>
      <GranularityToggler
        granularity={granularity}
        onChange={granularity => setGranularity(granularity)}
      />
      {!isLoading && (
        <AvgVelocityInfo
          granularity={granularity}
          avgVelocity={avgVelocity}
          type={type}
        />
      )}
      {loadingTimerAlert && (
        <LoadingAlert
          title={loadingTimerAlert.title}
          description={loadingTimerAlert.description}
        />
      )}
    </StyledHeader>
  );
};

export default Header;
